export default __webpack_public_path__ + "images/SH.a133ec8.png";